import _ from 'lodash'
import React from 'react'
import Table from './Table'

export default function ListView({ userIsClient, locations }) {
  return <Table locations={locations} userIsClient={userIsClient} />
}
